import { EmploymentType } from '@thesavingsgroup/enums/EmploymentType';
import { merge } from 'lodash';
import { useCallback, useMemo } from 'react';

import { PillowForm } from '../../../../../components/PillowForm';

const Controller = (props: any) => {
  const { presModel, send, context: workflowDetails } = props;
  const { coApplicant = {} } = workflowDetails || {};

  const onSubmit = useCallback(
    (updatedIncome: any) => {
      send('Next', {
        data: {
          incomes: {
            additional: (coApplicant.incomes.additional || []).concat({
              ...updatedIncome,
              incomeType: EmploymentType.OTHER,
            }),
          },
        },
      });
    },
    [coApplicant, send],
  );

  const onBack = useCallback(() => {
    send('Previous');
  }, [send]);

  const enhancedProps = useMemo(
    () =>
      merge(
        {},
        { presModel },
        {
          presModel: {
            template: {
              header: {
                onBack,
              },
            },
            form: {
              actions: {
                primary: {
                  handler: onSubmit,
                },
              },
            },
          },
        },
      ),
    [onSubmit, presModel, onBack],
  );

  return <PillowForm {...enhancedProps} />;
};

Controller.displayName = 'CoApplicantIncomeAdd.Controller';
export default Controller;
